// @ts-strict-ignore
import styled from 'styled-components';
import { useSelector } from 'src/store/store';
import PostLink from 'src/modules/shared/links/postLink';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event } from 'src/constants/footfall';
import i18n from 'src/utils/translate';
import { textSmall } from 'styles-js/mixins/typography';

export default function SkipFeaturedPostsButton() {
  const communitySlug = useSelector(({ context }) => context.currentCommunity.slug);
  const { id, postTypeId, urlEncodedTitle } = useSelector(({ pages }) => pages.singlePost.post);

  const onClick = () => trackFootfallEvent(Event.SkippedFeaturedPost);

  return (
    <StyledPostLink
      anchorToResponses={true}
      communitySlug={communitySlug}
      postId={id}
      postTypeId={postTypeId}
      urlEncodedTitle={urlEncodedTitle}
      onClick={onClick}
    >
      {i18n.t('Jump to replies')}
    </StyledPostLink>
  );
}

const StyledPostLink = styled(PostLink)`
  ${textSmall}
  color: ${({ theme }) => theme.colorTextLight};
`;
